import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterStateSnapshot } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HubModule } from '../../hub/hub.module';
import { PerfilModule } from '../../perfil/perfil.module';
import { BloquearPantallaModule } from '../../bloquear-pantalla/bloquear-pantalla.module';
import { GrupoRoutingModule } from './grupo-routing.module';
import { PaginacionModule } from '../../parcial/paginacion/paginacion.module';

import { PipesModule }             from '../../pipes/pipes.module';
import { ListaComponent } from './lista/lista.component';
import { FormularioComponent } from './formulario/formulario.component';
import { MatriculaComponent } from './matricula/matricula.component';
import { IncorporacionFinancieraComponent } from './incorporacion-financiera/incorporacion-financiera.component';
import { CambiarGrupoComponent } from './cambiar-grupo/cambiar-grupo.component';

import { AuthService } from '../../auth.service';

import { MenuModule } from '../../menu/menu.module';
import { ParcialModule } from '../../parcial/parcial.module';

//crud
import { CrudService } from '../../crud/crud.service';
import { CrudModule } from '../../crud/crud.module';
//fin crud
import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { NgSelect2Module } from "ng-select2";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GrupoRoutingModule,
    HubModule,
    PerfilModule,
    BloquearPantallaModule,
    PaginacionModule,
    PipesModule,
    MenuModule,
    ParcialModule,
    CrudModule,
    NguiAutoCompleteModule,
    NgSelect2Module
  ],
  declarations: [
    ListaComponent,
    FormularioComponent,
    MatriculaComponent,
    CambiarGrupoComponent,
    IncorporacionFinancieraComponent
  ],
  providers: [ AuthService, CrudService ]
})
export class GrupoModule { }
